import {
  ALL_CHART_TYPES,
  BLACK_HEX,
  DEFAULT_LINE_THICKNESS,
  DEFAULT_NORMALIZE_BY,
  DEFAULT_NORMALIZE_BY_SETTING
} from "constants/chart.constants";
import { EvaSource, TimeStep } from "constants/charts.enums";
import { createMergeWithDefaults } from "entities/utils";
import { RecoveryTimeChartRequestType, RecoveryTimeChartSettings } from "types";

import { MaxBinsSortOrderEnum } from "models/binSize";
import { EntityKind } from "models/entityKind";

import { BASE_CHART_REQUEST } from "./defaults";

export const DEFAULT_RECOVERY_TIME_CHART_SETTINGS: Partial<RecoveryTimeChartSettings> = {
  product: "Oil",
  otherProducts: [],
  primaryProducts: [],
  chartType: ALL_CHART_TYPES.RecoveryTime.id,
  showForecast: false,
  showWellCount: true,
  averageSettings: {
    color: BLACK_HEX,
    thickness: DEFAULT_LINE_THICKNESS
  },
  showAverage: false,
  p10Settings: {
    color: BLACK_HEX,
    thickness: DEFAULT_LINE_THICKNESS
  },
  showP10: false,
  p50Settings: {
    color: BLACK_HEX,
    thickness: DEFAULT_LINE_THICKNESS
  },
  showP50: false,
  p90Settings: {
    color: BLACK_HEX,
    thickness: DEFAULT_LINE_THICKNESS
  },
  showP90: false,
  pdenDataSourceSetting: {
    source: EvaSource.Public,
    timeStep: TimeStep.Month
  },
  forecastMode: "forecastTrump",
  useForecastStartDate: false,
  survivorBias: true,
  rateType: 0,
  showIndividualSeries: false,
  cutoff: 50,
  timeStep: TimeStep.Month,
  shutInMonths: 3,
  source: EvaSource.Public,
  normalizeBy: DEFAULT_NORMALIZE_BY,
  useWeightedRatioAverage: true,
  xVariable: {
    valueProperty: "Dates.Vintage_Year",
    displayTitle: "Vintage",
    canBin: true,
    dataType: "Integer",
    mappingName: "Dates.Vintage_Year",
    bin: null
  },
  yVariable: {
    valueProperty: "Well_Design.HzLength_m",
    displayTitle: "HzLengthEstimate",
    canBin: true,
    dataType: "Number",
    mappingName: "Well_Design.HzLength_m"
  },
  lockUnits: false,
  pressureChartSettings: {
    product: "Oil",
    productivityIndex: false
  },
  movingAverageDays: null,
  combineSameUnitAxis: false,
  recoveryFactorFields: []
};

export const DEFAULT_RECOVERY_TIME_REQUEST: Partial<RecoveryTimeChartRequestType> = {
  ...BASE_CHART_REQUEST,
  FilterId: "",
  requestId: "",
  ReverseColor: false,
  ColorPalette: {
    id: "-6",
    name: "Portland",
    shared: false,
    colors: ["rgb(12,51,131)"],
    preferredColors: [],
    paletteType: 0,
    colorScale: [],
    specialColors: null,
    thickness: [2],
    reverse: false
  },
  GroupBy: {
    title: "Resource Play",
    property: "Header.ResourcePlay",
    groupByField: "Header.ResourcePlay",
    pdenSource: "Public",
    canBin: false,
    dataType: "Text",
    categoryId: 1,
    tooltip: "",
    display: "",
    entityKind: EntityKind.Well,
    bin: {
      BinSize: 0,
      MinSize: null,
      MaxBins: null,
      MaxBinsSortOrder: MaxBinsSortOrderEnum.WellCount,
      GreaterThan: null,
      LessThan: null,
      Quantile: {
        quantileType: "NumberOfQuantile",
        numQuantiles: 4
      },
      BinType: "BinSize",
      UseDynamicBins: false
    },
    mode: undefined,
    forecastTrumpingSettings: undefined
  },
  sortBy: "AlphabeticalAsc",
  typeWells: [],
  normalizeTypeWell: true,
  userForecast: [],
  userForecastSettings: {
    forecastSourceFolder: null,
    secondaryUserForecastSourceFolder: null,
    excludeMcDanielForecasts: false,
    reserveCategory: null,
    excludeNoviForecasts: true,
    specialForecastFolders: ["McDaniel Research"]
  },
  forecastMode: "forecastTrump",
  useForecastStartDate: false,
  showGroupsNotInFilter: true,
  placeholderBinsEnabled: false,
  hasCheckedBins: true,
  syncClientPden: false,
  syncClientSchema: "",
  colorLockedItems: {},
  syncClientFcst: false,
  syncForecastRescat: "2111",
  normalizeBySetting: DEFAULT_NORMALIZE_BY_SETTING,
  chartSetting: DEFAULT_RECOVERY_TIME_CHART_SETTINGS as RecoveryTimeChartSettings,
  axisMinMax: {
    xMin: null,
    xMax: null,
    yMin: null,
    yMax: null
  },
  combineSameUnitAxis: false,
  isDefaultLockOn: true
};

export const generateRecoveryTimeRequestBody = createMergeWithDefaults(
  DEFAULT_RECOVERY_TIME_REQUEST
);
